import { createAction } from '@reduxjs/toolkit';

export const authFailed = createAction('auth/failed');
export const authChainFailed = createAction('auth/chain/failed');
